<template>
  <div>
    <h3 class="section-title mb-2">{{ $t('shop_information') }}</h3>
    <ul class="place-info">
      <li>
        <span>{{ $t('location') }}：</span>
        <span>{{ place.address }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  }
}
</script>
